module.exports = __webpack_public_path__ + "img/4step-image4.cb9235dc.png";